<div class="main" style="background-image:url('./assets/images/chettinad-link-storage[1].webp');background-position:fixed;background-repeat: no-repeat;background-size: cover;">
  <div class="d-flex h-100 justify-content-center align-items-center">
    <div class="mx-auto app-login-box col-md-8">
      <!-- <div class="text-center">
       <img src=".\assets\images\chettinad-link-logo.png" alt="logo" style="width:300px;">
      </div> -->
      <div class="modal-dialog w-80 mx-auto "  >
        <div class="modal-content" style="height:50vh;" style="background-color:rgba(240, 255, 255, 0.855)">
          <div class="modal-body">
            <div class="h5 modal-title text-center ">
              <div class="text-center">
                <!-- <h1 class="fw-bold" style="font-family: cursive;color:darkorange">User Login</h1> -->
                <img src=".\assets\images\chettinad-link-logo.png" alt="logo" style="width:250px;">
              </div>
            </div>
            <div id="exampleInputGroup1" role="group" aria-describedby="exampleInputGroup1__BV_description_"  style="margin-top:60px;" >
        
              <!-- <div class="col-lg-10 mx-4"> -->
                <!-- <input id="exampleInput1" type="email" placeholder="Enter Mobile Number..." required="required"
                  aria-required="true" class="form-control" aria-describedby="exampleInputGroup1__BV_description_"> -->
                   <!-- <input type="number" class="form-control fw-bold" placeholder="Enter Mobile Number..." style="font-family: cursive;">
              </div> -->
               <div class="input-group mx-4" style="max-width:80%;">
                <span class="input-group-text b" style="background-color:darkorange;border:none"><i class="bi bi-telephone-outbound-fill text-white"></i></span>
                <input type="number" class="form-control fw-bold p-2" formControlName="mobileno" placeholder=" Enter Mobile Number"   style="font-family: cursive; border: none; outline: none; box-shadow: none;">
              </div> 

              <div class="input-group mx-4"  style="margin-top:50px;max-width:80%;">
                <span class="input-group-text b" style="background-color:darkorange;border:none"><i class="bi bi-lock-fill text-white"></i></span>
                <input type="password" class="form-control fw-bold p-2 " formControlName="password" placeholder=" Enter password"style="font-family: cursive; border: none; outline: none; box-shadow:none;position: relative;">
                <!-- <i class="bi bi-eye-fill" style="position: absolute;left:350px; top:7px;"></i> -->
              </div>
            
            
            </div>
            
               
             <div class="text-center mt-5 mb-4">
              <button class="btn text-white fw-bold px-4 py-2 " style="background-color: darkorange;">Login</button>
             </div>
          
            
          </div>

          <!-- <div class="modal-footer clearfix" style="border:none">
          
            <div class="text-center !important" > 
              <button type="button" class="btn btn-primary btn-lg px-4">Login</button>
            </div>
          </div>
        </div>
      </div>  -->
      <!-- <div class="text-center text-white opacity-8 mt-3">
        Copyright © ArchitectUI 2019
      </div> -->
    </div>
  </div>
</div>